import { ReactElement } from 'react';

import { TranslatableText } from '@dreryk/react-common';

export enum PaymentsAndInvoicesNavParams {
   INVOICES = 'faktury',
}

export type PaymentsAndInvoicesNavTab = {
   param: PaymentsAndInvoicesNavParams;
   label: TranslatableText;
   content: ReactElement;
};
